import React, { useState, useEffect } from 'react';
import AppRouter from "./routers/AppRouter";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import { ThemeContextProvider } from "./contexts/ThemeContext";
import { BrowserRouter as Router } from 'react-router-dom'; 
import { Analytics } from "@vercel/analytics/react";
import { HiChevronUp } from 'react-icons/hi'; 
import '../src/App.css'; 

const App = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <ThemeContextProvider>
      <Router> 
        <Header />
        <AppRouter />
        <Analytics /> 
        {isVisible && (
        <div className="scroll-to-top" onClick={scrollToTop}>
          <HiChevronUp />
        </div>
        )}
        <Footer /> 
      </Router>
    </ThemeContextProvider>
  );
};

export default App;
